import { map } from 'rxjs';
import { Component, Input, OnInit, input, viewChild } from '@angular/core';
import { ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexYAxis, ApexTitleSubtitle, ChartType, NgApexchartsModule, ApexStroke } from 'ng-apexcharts';
import { JkBaseComponent } from 'jk-service';
import { jkLib } from 'jk-service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  title: ApexTitleSubtitle;
  stroke: ApexStroke;
};

@Component({
  selector: 'app-kd-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './kd-chart.component.html',
  styleUrl: './kd-chart.component.css'
})
export class KdChartComponent extends  JkBaseComponent implements OnInit {
  readonly chart = viewChild.required<ChartComponent>('chart');
  readonly type = input<ChartType>('line');
  readonly height = input<number>(250);
  public chartOptions: ChartOptions = this.setChartOptions();; // Partial<ChartOptions>;
  get XList():string[]{
    return this.itemList.map((item: any) => item.X);
  };
  _itemList: any[] = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get itemList(): any[] {
    if(!this._itemList) return [];
    return this._itemList;
  }
  set itemList(value: any[]) {
    this._itemList = value;
  }
  constructor() {
    super();
    //this.chartOptions = this.setChartOptions();
  }
  override ngOnInit(): void {
    super.ngOnInit();
  }
  async refresh() {
    //await this.getData(this.groupList, this.date);
    //await this.getItemList(this.item,this.date);
    this.setChartOptions();
  }
  setSeries(): ApexAxisChartSeries {
    let series: ApexAxisChartSeries = [];
    if(this.itemList){
      series = [
      {
        name: 'K',
        data: this.itemList.map((item: any) => item.K)
      },
      {
        name: 'D',
        data: this.itemList.map((item: any) => item.D)
      }
    ]};
    return series;
  }
  setChartOptions() {
    this.chartOptions = {
      series: this.setSeries(),
      chart: {
        height: this.height(),
        type: this.type(),
      },
      title: {
        text: this.getTitle(),
      },
      xaxis: {
        categories: this.XList,
        labels: {show: false},
      },
      yaxis: {
        title: {
          text: 'Value'
        }
      },
      stroke: { width: [1, 1] },
    };
    return this.chartOptions;
  }
  getTitle(){
    if((!this.itemList) || (this.itemList.length === 0)) return ''
    else{
      let str = 'K:'+ jkLib.percentStr(this.itemList[this.itemList.length-1].K,2)+' D:'+jkLib.percentStr(this.itemList[this.itemList.length-1].D,2);
      //console.log(str);
      return str;
    }
  }

}
